export const recipesContainer = {
    backgroundColor: theme => theme.palette.background.default,
    color: theme => theme.palette.text.primary,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  };
  
  export const fixedHeader = {
    position: 'fixed',
    top: { xs: '0px', sm: '64px' },
    left: 0,
    width: { xs: '100%', sm: 'calc(100% - 17px)' },
    zIndex: 50,
    backgroundColor: theme => theme.palette.background.default,
    borderBottom: theme => `1px solid ${theme.palette.divider}`,
    boxShadow: '0 6px 10px -2px rgba(0, 0, 0, 0.15)',
  };
  
  export const container = {
    pb: { xs: 0.5, sm: 0.75 },
    pt: { xs: 0.75, sm: 1 },
    px: { xs: 1.5, sm: 2 },
  };